module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list-inline"
  }, [(_vm.mediaLinks.facebookUrl) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.mediaLinks.facebookUrl,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-f"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mediaLinks.twitterUrl) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.mediaLinks.twitterUrl,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "twitter"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mediaLinks.linkedInUrl) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.mediaLinks.linkedInUrl,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mediaLinks.googlePlusUrl) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.mediaLinks.googlePlusUrl,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "google-plus"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mediaLinks.youTubeUrl) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.mediaLinks.youTubeUrl,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "youtube"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-263825d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/shared/SocialMediaButtonsComponent.vue
// module id = 1406
// module chunks = 1